/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { CircularProgress, Typography } from "@mui/material";
import Document from "react-pdf/dist/cjs/Document.js";

import Page from "react-pdf/dist/cjs/Page.js";
import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";
import _cookies from "../../../shared/utils/_cookies";

import { useEffect, useRef, useMemo, useState } from "react";
import { cn } from "../../../shared/utils/cn";
import { pdfjs, usePageContext } from "react-pdf/dist/cjs/index.js";
import workerContent from "./pdf.worker.min.json";

var workerBlob = new Blob([workerContent], { type: "text/javascript" });
var workerBlobURL = URL.createObjectURL(workerBlob);
pdfjs.GlobalWorkerOptions.workerSrc = workerBlobURL;

function degreesToRadians(degrees) {
  return degrees * (Math.PI / 180);
}

const options = {
  cMapUrl: "/cmaps/",
  standardFontDataUrl: "/standard_fonts/",
};

function CustomRenderer(enableWatermark) {
  const pageContext = usePageContext();

  const [isRendered, setIsRendered] = useState(false);

  const { _className, page, rotate, scale, ...rest } = pageContext;

  const canvasRef = useRef(null);

  const viewport = useMemo(
    () => page.getViewport({ scale, rotation: rotate }),
    [page, rotate, scale]
  );

  function draw(_txt, canvas) {
    var context = canvas.getContext("2d");
    var { width, height } = canvas;
    const angle = 45;
    var txtHeight = 35;
    var offset = 100;
    var w = Math.ceil(context.measureText(_txt).width);
    var txt = new Array(w * 2).join(_txt + " "); //change the multipler for more lines
    context.font = `24px sans-serif`;
    context.translate(width / 2, -height / 4);

    for (var i = 0; i < Math.ceil(height / txtHeight); i++) {
      context.rotate(degreesToRadians(angle));
      context.fillStyle = "rgba(255, 0, 255, .15)";
      context.fillText(txt, -(i * offset), i * txtHeight);
      context.rotate(degreesToRadians(-angle));
    }
  }

  function drawPageOnImage() {
    if (!page) {
      return;
    }

    if (!canvasRef.current) {
      return;
    }

    // const canvas = document.createElement("canvas");
    // canvas.width = viewport.width;
    // canvas.height = viewport.height;
    setIsRendered(false);
    const context = canvasRef.current.getContext("2d", { alpha: false });

    const renderContext = {
      canvasContext: context,
      viewport,
    };

    // context.save();

    const cancellable = page.render(renderContext);
    // context.restore();
    // draw("teste", canvasRef.current);

    const runningTask = cancellable;

    cancellable.promise
      .then(() => {
        // image.src = canvas.toDataURL();
        setIsRendered(true);
      })
      .catch(() => {
        // Intentionally empty
      });

    return () => {
      runningTask.cancel();
    };
  }

  useEffect(drawPageOnImage, [page, viewport]);

  useEffect(() => {
    if (isRendered && enableWatermark) {
      draw(_cookies.getItem("auth").user?.nome, canvasRef.current);
    }
  }, [isRendered]);

  return (
    <div className="relative flex flex-col items-center">
      <canvas
        className={`${_className}__image`}
        height={viewport.height}
        ref={canvasRef}
        width={viewport.width}
      />
      <span
        className={cn(
          "absolute bg-gray-300 flex items-center justify-center top-0 right-0 left-0 bottom-0",
          isRendered && "hidden"
        )}
      >
        <CircularProgress />
      </span>
    </div>
  );
}

function PageComponent({ enableWatermark, ...rest }) {
  const [isRendered, setIsRendered] = useState();

  const handleRenderSuccess = () => {
    setIsRendered(true);
  };

  return (
    <Page
      {...rest}
      enableWatermark={enableWatermark}
      onRenderSuccess={handleRenderSuccess}
      renderMode="custom"
      customRenderer={() => CustomRenderer(enableWatermark)}
      loading={<div className="bg-blue-500"> Carregando</div>}
      error={<>Um erro aconteceu</>}
    />
  );
}

function PDFViewer({
  DocumentProps = {},
  PageProps = {},
  file = "https://TEMPLATE.cadernovirtual.com.br/Membros/recursos/RECURSO_vuUAAmASmyaV4cO896rF_106042025094603.pdf",
}) {
  const [numPages, setNumPages] = useState();

  function onDocumentLoadSuccess({ numPages, ...rest }) {
    setNumPages(numPages);
  }

  return (
    <Document
      {...DocumentProps}
      className={cn("bg-slate-300 overflow-auto", DocumentProps.className)}
      file={file}
      onLoadSuccess={onDocumentLoadSuccess}
      options={options}
      loading={
        <CircularProgress className="absolute top-0 right-0 left-0 bottom-0" />
      }
    >
      {Array(...Array(numPages))
        .map((x, i) => i + 1)
        .map((pageNumber, index) => {
          return (
            <>
              <Typography className="w-full p-1 text-center">{`Página ${pageNumber} de ${numPages}`}</Typography>
              <PageComponent {...PageProps} pageNumber={pageNumber} />
            </>
          );
        })}
    </Document>
  );
}

export default PDFViewer;
